/**
 * REVIEW ENTITIES
 *
 * @version 0.1
 */

import React from 'react';
import { FormattedMessage } from 'react-intl';
import ReviewEntitiesButtonAndParagraphs from './ReviewEntitiesButtonAndParagraphs';

function ReviewEntities() {

    return (

        <div className="upload-wizard__button-container">

            <div className="card-title">
                <FormattedMessage id="Entities_Steps_UIText_batchUpload.Step3Heading" />
            </div>

            <div className="card-image step-three"></div>

            <div className="step-heading">
                <FormattedMessage id="Entities_Steps_UIText_batchUpload.stepArrow3" />
            </div>

            <p><FormattedMessage id="Entities_Steps_UIText_batchUpload.step3Instruction1" /></p>

            <ReviewEntitiesButtonAndParagraphs />

        </div>

    );

}

export default ReviewEntities;


// WEBPACK FOOTER //
// ./src/scripts/pages/BatchUpload/submodules/InitialStage/ReviewEntities.jsx